import { ClientService } from "@cms/iprox";
import { createUrl } from "@core/utils";

export class I18nService extends ClientService {
  constructor(apiUrl: string) {
    super(createUrl(apiUrl, "formulierencontent"));
  }

  getTranslations = async (namespace: string, language: string) => {
    return namespace.includes("all-forms")
      ? this.client.contentFormsGenericForm("all-forms", language)
      : this.client.contentFormsForm(namespace, language);
  };
}
